import type { FullGoalDefinitionViewModel, GoalDefinitionViewModel } from '@generated';

export function isFullGoalDefinition(x: GoalDefinitionViewModel | FullGoalDefinitionViewModel): x is FullGoalDefinitionViewModel {
	return 'definitionFormControls' in x;
}
